// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { DetectionZoneCardinalDirection } from "./Shared.DetectionZoneCardinalDirection.gen";
import { TurnType } from "./Shared.TurnType.gen";

export interface ITmcColumnDefinition {
	key: string | undefined;

	direction: DetectionZoneCardinalDirection;

	turnType: TurnType | undefined;

	laneMask: number;

	displayLabel: string | undefined;

	$type?: string | undefined;
}
export class TmcColumnDefinition {
	constructor(data?: ITmcColumnDefinition) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	key: string | undefined;

	direction: DetectionZoneCardinalDirection = 0;

	turnType: TurnType | undefined;

	laneMask: number = 0;

	displayLabel: string | undefined;

	static $type: string = "CoreApi.Models.Reports.TmcColumnDefinition, ";
	$type?: string | undefined = TmcColumnDefinition.$type;
}

